import { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/lib/roles";
import { download } from "@/lib/wh";

const FIELDS = [["photo", "Foto"], ["qr", "QR Code"], ["barcode", "Codice a barre"], ["desc", "Descrizione"], ["purchase", "Prezzo di acquisto"], ["sale", "Prezzo di vendita"], ["status", "Stato"]];

export function PdfDialog({ open, onOpenChange, lotId = "", status = "", q = "", title, wh = "mercatino" }) {
  const { user } = useAuth();
  const [kind, setKind] = useState("grid");
  const [sel, setSel] = useState(new Set(FIELDS.map(([k]) => k)));
  const [busy, setBusy] = useState("");
  const fields = FIELDS.filter(([k]) => k !== "purchase" || can(user, "wh_cost"));
  const toggle = (k) => setSel((s) => { const n = new Set(s); n.has(k) ? n.delete(k) : n.add(k); return n; });
  const run = async (what) => {
    setBusy(what);
    try {
      if (what === "csv") await download("/wh/export.csv", { wh, lot_id: lotId, status }, "inventario.csv");
      else await download("/wh/pdf", { wh, kind, lot_id: lotId, status, q, fields: [...sel].join(",") }, `magazzino_${kind === "grid" ? "griglia" : "elenco"}.pdf`);
    } catch (e) { toast.error(formatApiError(e)); }
    setBusy("");
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[95dvh] overflow-y-auto" data-testid="pdf-dialog">
        <DialogHeader><DialogTitle>Esporta {title}</DialogTitle><DialogDescription>Vengono inclusi gli articoli che corrispondono ai filtri attuali.</DialogDescription></DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          {[["grid", "PDF a griglia"], ["list", "PDF elenco dettagliato"]].map(([k, l]) => (
            <button key={k} type="button" onClick={() => setKind(k)} data-testid={`pdf-kind-${k}`}
              className={`h-11 rounded-xl border text-sm font-semibold ${kind === k ? "bg-[var(--ink)] text-white border-[var(--ink)]" : "bg-white border-[var(--border)]"}`}>{l}</button>
          ))}
        </div>
        {kind === "grid" ? (
          <div className="grid grid-cols-2 gap-2" data-testid="pdf-fields">
            {fields.map(([k, l]) => (
              <label key={k} className="flex items-center gap-2 text-sm"><input type="checkbox" className="h-4 w-4" checked={sel.has(k)} onChange={() => toggle(k)} data-testid={`pdf-field-${k}`} /> {l}</label>
            ))}
          </div>
        ) : <p className="text-sm text-[var(--muted)]">Tabella con codice, descrizione, categoria, quantità, prezzi, stato e data, più il riepilogo economico finale.</p>}
        <div className="flex flex-wrap gap-2">
          <button onClick={() => run("pdf")} disabled={!!busy} className="btn-primary h-11 px-5" data-testid="pdf-download-button">{busy === "pdf" ? <Loader2 className="h-5 w-5 animate-spin" /> : <FileDown className="h-5 w-5" />} Scarica PDF</button>
          <button onClick={() => run("csv")} disabled={!!busy} className="btn-secondary h-11 px-5" data-testid="csv-download-button">{busy === "csv" ? <Loader2 className="h-5 w-5 animate-spin" /> : null} Inventario Excel (CSV)</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
